import { getUserUUID } from '@buzzfeed/bf-utils/lib/userid';

const IS_PROD = typeof window === 'object' && window.HP && window.HP.env === 'production';
// if cet is disabled we should not call getUserUUID because that sets the bf_visit cookie and we don't want any cookies created (for example on FR edition) cant return empty string because connatix waits for window.HUFFPOST.params.clientUUID
window.HUFFPOST.params.clientUUID = window.HUFFPOST.cetEnabled ? getUserUUID({ env: IS_PROD ? 'prod' : 'stage', legacy: false }) : ' ';
